module.exports = __webpack_public_path__ + "img/87.883e6ed7.jpg";